// Saga for Navigation Menu

import { call, put, all, takeEvery } from "redux-saga/effects";
import {
  GET_NAVIGATION_MENU,
  GET_MENU_NAVIGATION_LIST,
  CREATE_SINGLE_MENU_NAVIGATION,
  UPDATE_SINGLE_MENU_NAVIGATION,
  DELETE_SINGLE_MENU_NAVIGATION,
  GET_AVAILABLE_MENU_NAVIGATION_ITEMS,
  GET_SINGLE_NAVIGATION_MENU,
  GET_MENU_ITEM_LIST,
  GET_SINGLE_MENU_ITEM_DATA,
  CREATE_SINGLE_MENU_ITEM,
  UPDATE_SINGLE_MENU_ITEM,
  DELETE_SINGLE_MENU_ITEM,
  CREATE_MASTER_MENU_NAV_ITEM,
  // Global menus - Task 24886
  GET_MASTER_MENU_NAV_LIST,
  GET_MASTER_MENU_NAV_DATA,
  CREATE_MASTER_MENU_NAV,
  UPDATE_MASTER_MENU_NAV,
  DELETE_MASTER_MENU_NAV,
  ROLLOUT_MASTER_MENU_NAV,
} from "./actionType";

import {
  getNavigationMenuSuccess,
  getNavigationMenuFailure,
  getMenuNavigationListSuccess,
  getMenuNavigationListFailure,
  createSingleMenuNavigationSuccess,
  createSingleMenuNavigationFailure,
  updateSingleMenuNavigationSuccess,
  updateSingleMenuNavigationFailure,
  deleteSingleMenuNavigationSuccess,
  deleteSingleMenuNavigationFailure,
  getAvailableMenuNavigationItemsSuccess,
  getAvailableMenuNavigationItemsFailure,
  getSingleNavigationMenuSuccess,
  getSingleNavigationMenuFailure,
  getMenuItemListSuccess,
  getMenuItemListFailure,
  getSingleMenuItemDataSuccess,
  getSingleMenuItemDataFailure,
  createSingleMenuItemSuccess,
  createSingleMenuItemFailure,
  updateSingleMenuItemSuccess,
  updateSingleMenuItemFailure,
  deleteSingleMenuItemSuccess,
  deleteSingleMenuItemFailure,
  createMasterMenuNavItemSuccess,
  createMasterMenuNavItemFailure,
  getMasterMenuNavListSuccess,
  getMasterMenuNavListFailure,
  getMasterMenuNavDataSuccess,
  getMasterMenuNavDataFailure,
  createMasterMenuNavSuccess,
  createMasterMenuNavFailure,
  updateMasterMenuNavSuccess,
  updateMasterMenuNavFailure,
  deleteMasterMenuNavSuccess,
  deleteMasterMenuNavFailure,
  rolloutMasterMenuNavSuccess,
  rolloutMasterMenuNavFailure,
} from "./action";

import {
  getNavigationMenuApiCall,
  getMenuNavigationListApiCall,
  createSingleMenuNavigationApiCall,
  updateSingleMenuNavigationApiCall,
  deleteSingleMenuNavigationApiCall,
  getAvailableMenuNavigationItemsApiCall,
  getSingleNavigationMenuApiCall,
  getMenuItemListApiCall,
  getSingleMenuItemDataApiCall,
  createSingleMenuItemApiCall,
  updateSingleMenuItemApiCall,
  deleteSingleMenuItemApiCall,
  createMasterMenuNavItemApiCall,
  getMasterMenuNavListApiCall,
  getMasterMenuNavDataApiCall,
  createMasterMenuNavApiCall,
  updateMasterMenuNavApiCall,
  deleteMasterMenuNavApiCall,
  rolloutMasterMenuNavApiCall,
} from "../../helpers/fakebackend_helper";

function* getNavigationMenuSaga(action) {
  try {
    const response = yield call(getNavigationMenuApiCall, action.payload);
    yield put(getNavigationMenuSuccess(response));
  } catch (error) {
    yield put(getNavigationMenuFailure(error));
  }
}

export function* watchGetNavigationMenuSaga() {
  yield takeEvery(GET_NAVIGATION_MENU, getNavigationMenuSaga);
}

// Get Menu Navigation List
function* getMenuNavigationListSaga(action) {
  try {
    const response = yield call(getMenuNavigationListApiCall, action.payload);
    yield put(getMenuNavigationListSuccess(response));
  } catch (error) {
    yield put(getMenuNavigationListFailure(error));
  }
}

export function* watchGetMenuNavigationListSaga() {
  yield takeEvery(GET_MENU_NAVIGATION_LIST, getMenuNavigationListSaga);
}

// Create Single Menu Navigation
function* createSingleMenuNavigationSaga(action) {
  try {
    const response = yield call(
      createSingleMenuNavigationApiCall,
      action.payload
    );
    yield put(createSingleMenuNavigationSuccess(response));
  } catch (error) {
    yield put(createSingleMenuNavigationFailure(error));
  }
}

export function* watchCreateSingleMenuNavigationSaga() {
  yield takeEvery(
    CREATE_SINGLE_MENU_NAVIGATION,
    createSingleMenuNavigationSaga
  );
}

// Update Single Menu Navigation
function* updateSingleMenuNavigationSaga(action) {
  try {
    const response = yield call(
      updateSingleMenuNavigationApiCall,
      action.payload
    );
    yield put(updateSingleMenuNavigationSuccess(response));
  } catch (error) {
    yield put(updateSingleMenuNavigationFailure(error));
  }
}

export function* watchUpdateSingleMenuNavigationSaga() {
  yield takeEvery(
    UPDATE_SINGLE_MENU_NAVIGATION,
    updateSingleMenuNavigationSaga
  );
}

// Delete Single Menu Navigation
function* deleteSingleMenuNavigationSaga(action) {
  try {
    const response = yield call(
      deleteSingleMenuNavigationApiCall,
      action.payload
    );
    yield put(deleteSingleMenuNavigationSuccess(response));
  } catch (error) {
    yield put(deleteSingleMenuNavigationFailure(error));
  }
}

export function* watchDeleteSingleMenuNavigationSaga() {
  yield takeEvery(
    DELETE_SINGLE_MENU_NAVIGATION,
    deleteSingleMenuNavigationSaga
  );
}

// Get Available Menu Navigation Items
function* getAvailableMenuNavigationItemsSaga() {
  try {
    const response = yield call(getAvailableMenuNavigationItemsApiCall);
    yield put(getAvailableMenuNavigationItemsSuccess(response));
  } catch (error) {
    yield put(getAvailableMenuNavigationItemsFailure(error));
  }
}

export function* watchGetAvailableMenuNavigationItemsSaga() {
  yield takeEvery(
    GET_AVAILABLE_MENU_NAVIGATION_ITEMS,
    getAvailableMenuNavigationItemsSaga
  );
}

// Get Single Navigation Menu
function* getSingleNavigationMenuSaga(action) {
  try {
    const response = yield call(getSingleNavigationMenuApiCall, action.payload);
    yield put(getSingleNavigationMenuSuccess(response));
  } catch (error) {
    yield put(getSingleNavigationMenuFailure(error));
  }
}

export function* watchGetSingleNavigationMenuSaga() {
  yield takeEvery(GET_SINGLE_NAVIGATION_MENU, getSingleNavigationMenuSaga);
}

// Get Menu Item List
function* getMenuItemListSaga(action) {
  try {
    const response = yield call(getMenuItemListApiCall, action.payload);
    yield put(getMenuItemListSuccess(response));
  } catch (error) {
    yield put(getMenuItemListFailure(error));
  }
}

export function* watchGetMenuItemListSaga() {
  yield takeEvery(GET_MENU_ITEM_LIST, getMenuItemListSaga);
}

// Get Single Menu Item DATA
function* getSingleMenuItemDataSaga(action) {
  try {
    const response = yield call(getSingleMenuItemDataApiCall, action.payload);
    yield put(getSingleMenuItemDataSuccess(response));
  } catch (error) {
    yield put(getSingleMenuItemDataFailure(error));
  }
}

export function* watchGetSingleMenuItemDataSaga() {
  yield takeEvery(GET_SINGLE_MENU_ITEM_DATA, getSingleMenuItemDataSaga);
}

// Create Single Menu Item
function* createSingleMenuItemSaga(action) {
  try {
    const response = yield call(createSingleMenuItemApiCall, action.payload);
    yield put(createSingleMenuItemSuccess(response));
  } catch (error) {
    yield put(createSingleMenuItemFailure(error));
  }
}

export function* watchCreateSingleMenuItemSaga() {
  yield takeEvery(CREATE_SINGLE_MENU_ITEM, createSingleMenuItemSaga);
}

// Update Single Menu Item
function* updateSingleMenuItemSaga(action) {
  try {
    const response = yield call(updateSingleMenuItemApiCall, action.payload);
    yield put(updateSingleMenuItemSuccess(response));
  } catch (error) {
    yield put(updateSingleMenuItemFailure(error));
  }
}

export function* watchUpdateSingleMenuItemSaga() {
  yield takeEvery(UPDATE_SINGLE_MENU_ITEM, updateSingleMenuItemSaga);
}

// Delete Single Menu Item
function* deleteSingleMenuItemSaga(action) {
  try {
    const response = yield call(deleteSingleMenuItemApiCall, action.payload);
    yield put(deleteSingleMenuItemSuccess(response));
  } catch (error) {
    yield put(deleteSingleMenuItemFailure(error));
  }
}

export function* watchDeleteSingleMenuItemSaga() {
  yield takeEvery(DELETE_SINGLE_MENU_ITEM, deleteSingleMenuItemSaga);
}



// Create Master Menu Nav Item
function* createMasterMenuNavItemSaga(action) {
  try {
    const response = yield call(createMasterMenuNavItemApiCall, action.payload);
    yield put(createMasterMenuNavItemSuccess(response));
  } catch (error) {
    yield put(createMasterMenuNavItemFailure(error));
  }
}

export function* watchCreateMasterMenuNavItemSaga() {
  yield takeEvery(CREATE_MASTER_MENU_NAV_ITEM, createMasterMenuNavItemSaga);
}

// ---------------------------------------------------------------------------
// Global menus - Task 24886
// ---------------------------------------------------------------------------
function* getMasterMenuNavListSaga(action) {
  try {
    const response = yield call(getMasterMenuNavListApiCall, action.payload);
    yield put(getMasterMenuNavListSuccess(response));
  } catch (error) {
    yield put(getMasterMenuNavListFailure(error));
  }
}
export function* watchGetMasterMenuNavListSaga() {
  yield takeEvery(GET_MASTER_MENU_NAV_LIST, getMasterMenuNavListSaga);
}

function* getMasterMenuNavDataSaga(action) {
  try {
    const response = yield call(getMasterMenuNavDataApiCall, action.payload);
    yield put(getMasterMenuNavDataSuccess(response));
  } catch (error) {
    yield put(getMasterMenuNavDataFailure(error));
  }
}
export function* watchGetMasterMenuNavDataSaga() {
  yield takeEvery(GET_MASTER_MENU_NAV_DATA, getMasterMenuNavDataSaga);
}

function* createMasterMenuNavSaga(action) {
  try {
    const response = yield call(createMasterMenuNavApiCall, action.payload);
    yield put(createMasterMenuNavSuccess(response));
  } catch (error) {
    yield put(createMasterMenuNavFailure(error));
  }
}
export function* watchCreateMasterMenuNavSaga() {
  yield takeEvery(CREATE_MASTER_MENU_NAV, createMasterMenuNavSaga);
}

function* updateMasterMenuNavSaga(action) {
  try {
    const response = yield call(updateMasterMenuNavApiCall, action.payload);
    yield put(updateMasterMenuNavSuccess(response));
  } catch (error) {
    yield put(updateMasterMenuNavFailure(error));
  }
}
export function* watchUpdateMasterMenuNavSaga() {
  yield takeEvery(UPDATE_MASTER_MENU_NAV, updateMasterMenuNavSaga);
}

function* deleteMasterMenuNavSaga(action) {
  try {
    const response = yield call(deleteMasterMenuNavApiCall, action.payload);
    yield put(deleteMasterMenuNavSuccess(response));
  } catch (error) {
    yield put(deleteMasterMenuNavFailure(error));
  }
}
export function* watchDeleteMasterMenuNavSaga() {
  yield takeEvery(DELETE_MASTER_MENU_NAV, deleteMasterMenuNavSaga);
}

function* rolloutMasterMenuNavSaga(action) {
  try {
    const response = yield call(rolloutMasterMenuNavApiCall, action.payload);
    yield put(rolloutMasterMenuNavSuccess(response));
  } catch (error) {
    yield put(rolloutMasterMenuNavFailure(error));
  }
}
export function* watchRolloutMasterMenuNavSaga() {
  yield takeEvery(ROLLOUT_MASTER_MENU_NAV, rolloutMasterMenuNavSaga);
}

function* NavigationMenu() {
  yield all([
    watchGetNavigationMenuSaga(),
    watchGetMenuNavigationListSaga(),
    watchCreateSingleMenuNavigationSaga(),
    watchUpdateSingleMenuNavigationSaga(),
    watchDeleteSingleMenuNavigationSaga(),
    watchGetAvailableMenuNavigationItemsSaga(),
    watchGetSingleNavigationMenuSaga(),
    watchGetMenuItemListSaga(),
    watchGetSingleMenuItemDataSaga(),
    watchCreateSingleMenuItemSaga(),
    watchUpdateSingleMenuItemSaga(),
    watchDeleteSingleMenuItemSaga(),
    watchCreateMasterMenuNavItemSaga(),
    watchGetMasterMenuNavListSaga(),
    watchGetMasterMenuNavDataSaga(),
    watchCreateMasterMenuNavSaga(),
    watchUpdateMasterMenuNavSaga(),
    watchDeleteMasterMenuNavSaga(),
    watchRolloutMasterMenuNavSaga(),
  ]);
}

export default NavigationMenu;
